import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faMinusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { connectReduxReducers } from "hocs";

const ViewContent = ({ auth, views, id_content }) => {
  const [view, setView] = React.useState(false);

  React.useEffect(() => {
    getView();
    // eslint-disable-next-line
  }, []);

  const getView = (id = id_content) => {
    if (id !== undefined) {
      views.getContentView(id, ({ data, status }) => {
        setView(status === 200 ? true : false);
      });
    }
  };

  return (
    <>
      {view ? (
        <FontAwesomeIcon
          title="Ya has visto este contenido"
          icon={faCheckCircle}
          className="pz-course-modules__module--lesson--view--active"
        ></FontAwesomeIcon>
      ) : (
        <FontAwesomeIcon
          title="No has visto este contenido"
          icon={faMinusCircle}
          className="pz-course-modules__module--lesson--view"
        ></FontAwesomeIcon>
      )}
    </>
  );
};

export default connectReduxReducers(ViewContent, "views");
